<template>
  <div>
    <router-link v-if="mini" class="cart-mini" :to="{ name: 'cart' }">
      <i class="fas fa-shopping-cart fa-2x"></i>
      <div class="badge" :class="{ large: animTrigger }">
        <div class="card-count">
          {{ total }}
        </div>
      </div>
    </router-link>

    <div v-else class="cart-full">
      <v-card
        v-if="_.isEmpty(products) && step === 1"
        class="empty-msg"
        elevation="1"
      >
        <div>Ваша корзина пуста</div>
      </v-card>

      <div v-else>
        <v-card elevation="1" :loading="loading">
          <v-window v-model="step">
            <v-window-item :value="1">
              <div>
                <div class="cart-grid">
                  <div class="header">№</div>
                  <div class="header">Наименование</div>
                  <div class="header">Колличество</div>
                  <div class="header">Цена</div>
                  <div class="header">Сумма</div>
                  <div class="header"></div>
                </div>

                <div class="cart-grid" v-for="(prod, i) in products">
                  <div class="cell">{{ prod.vendor_code }}</div>
                  <div class="cell">{{ prod.name }}</div>
                  <div class="cell counter">
                    <v-btn
                      :small="$vuetify.breakpoint.smAndDown"
                      icon
                      @click="
                        prod.count !== 0
                          ? $store.commit('Cart/changeCount', {
                              vendor_code: prod.vendor_code,
                              count: --prod.count,
                            })
                          : ''
                      "
                    >
                      <v-icon :small="$vuetify.breakpoint.smAndDown"
                        >remove</v-icon
                      >
                    </v-btn>
                    <div class="mx-1">
                      {{ prod.count }}
                    </div>
                    <v-btn
                      :small="$vuetify.breakpoint.smAndDown"
                      icon
                      @click="
                        $store.commit('Cart/changeCount', {
                          vendor_code: prod.vendor_code,
                          count: ++prod.count,
                        })
                      "
                    >
                      <v-icon :small="$vuetify.breakpoint.smAndDown"
                        >add</v-icon
                      >
                    </v-btn>
                  </div>
                  <div class="cell">{{ prod.cost | currency }}</div>
                  <div class="cell">
                    {{ (prod.cost * prod.count) | currency }}
                  </div>
                  <div class="cell">
                    <v-btn
                      :small="$vuetify.breakpoint.smAndDown"
                      icon
                      @click="delProduct(prod.vendor_code)"
                    >
                      <v-icon :small="$vuetify.breakpoint.smAndDown"
                        >delete</v-icon
                      >
                    </v-btn>
                  </div>
                </div>

                <div class="cart-grid">
                  <div class="footer">Сумма</div>
                  <div class="footer"></div>
                  <div class="footer"></div>
                  <div class="footer"></div>
                  <div class="footer">{{ sum | currency }}</div>
                  <div class="footer"></div>
                </div>
              </div>
            </v-window-item>

            <v-window-item :value="2">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" class="py-0">
                    <v-text-field
                      v-model="firstname"
                      label="Имя *"
                      v-validate="'required'"
                      :error-messages="errors && errors.first('firstname')"
                      name="firstname"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-0">
                    <v-text-field
                      v-model="surname"
                      label="Фамилия *"
                      v-validate="'required'"
                      :error-messages="errors && errors.first('surname')"
                      name="surname"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <da-phone-field
                  v-model="phoneNumbers"
                  v-validate="'required|phone'"
                  :error-messages="errors && errors.first('phoneNumbers')"
                  name="phoneNumbers"
                  label="Телефон для связи *"
                ></da-phone-field>
                <v-text-field
                  v-model="linkEmails"
                  label="E-mail *"
                  v-validate="'required|email'"
                  :error-messages="errors && errors.first('linkEmails')"
                  name="linkEmails"
                ></v-text-field>
                <span class="caption grey--text text--darken-1">
                  * поля, обязательные для заполения
                </span>
              </v-card-text>
            </v-window-item>

            <v-window-item :value="3">
              <div class="pa-4 text-center">
                <v-icon class="mb-4" size="100" color="success"
                  >event_available</v-icon
                >
                <h3 class="title font-weight-light">
                  <div class="font-weight-bold">
                    Заказ принят
                  </div>
                  В ближайшее время с Вами свяжется менеджер для подтверждения заявки <br>
                  Телефон менеджера: +7 (988) 312-14-14
                </h3>
                <span class="caption grey--text">Спасибо за заказ</span>
              </div>
            </v-window-item>
          </v-window>
        </v-card>
        <div
          class="mt-4 d-flex align-center"
          :class="{ 'px-2': $vuetify.breakpoint.xs }"
        >
          <v-btn
            v-if="step === 2"
            class="grey darken-2"
            depressed
            dark
            tile
            @click="step--"
          >
            Вернуться
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-show="step !== 3"
            class="yellow darken-2"
            tile
            depressed
            @click="step === 1 ? step++ : sendOrder()"
            :loading="loading"
          >
            {{ step === 1 ? "Оформить заказ" : "Подтвердить" }}
          </v-btn>
          <v-btn
            v-show="step === 3"
            class="yellow darken-2"
            tile
            depressed
            :to="{ name: 'main' }"
          >
            На главную
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import DaPhoneField from "~~/components/form/DaPhoneField.vue";

export default {
  inject: ["$validator"],
  created() {
    this.restoreProducts();
    setTimeout(() => (this.animPermission = true), 100);
  },
  components: { DaPhoneField },
  data() {
    return {
      step: 1,
      firstname: null,
      surname: null,
      phoneNumbers: null,
      linkEmails: null,
      loading: false,
      animTrigger: false,
      animPermission: false,
    };
  },
  props: {
    mini: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    // restore Products from local storage
    restoreProducts() {
      if (this.mini) {
        let products = this.storageLimit().get(this.cacheKey) || {};
        this.$store.commit("Cart/clear");
        for (let [vendor_code, product] of Object.entries(products)) {
          this.$store.commit("Cart/addProduct", product);
        }
      }
    },
    delProduct(vendor_code) {
      this.$store.commit("Cart/delProduct", vendor_code);
    },

    async sendOrder() {
      if (!(await this.$validator.validateAll())) return;
      this.loading = true;
      const response = await this.$store
        .dispatch("Cart/createOrder", {
          products: this.products,
          firstname: this.firstname,
          surname: this.surname,
          phone: this.phoneNumbers,
          email: this.linkEmails,
          context: this,
        })
        .catch(() => (this.loading = false));

      // if (response.data && response.data.data && response.data.data.payUrl) {
        this.step = 3;
        this.loading = false;
        // this.formQuery.post(
        //   response.data.data.payUrl,
        //   response.data.data.payData
        // );
      // }
    },
  },

  computed: {
    ...mapState({
      products: (state) => state.Cart.products,
      cacheKey: (state) => state.Cart.cacheKey,
    }),
    ...mapGetters("Cart", ["total", "sum"]),
    ...mapGetters(["storageLimit", "formQuery"]),
  },

  watch: {
    total() {
      if (!this.animTrigger && this.animPermission) {
        this.animTrigger = true;
        // setTimeout(() => (this.animTrigger = false), 150);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-mini {
  position: relative;
  max-width: 45px;
  .badge {
    position: absolute;
    top: -14px;
    right: -12px;
    background-color: #f02f40;
    width: 30px;
    height: 16px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    transition: 0.1s;

    &.large {
      transform: scale(2);
    }
  }
  .card-count {
    text-align: center;
    margin-top: 1px;
  }
}
.cart-full {
  .empty-msg {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
  }
  .cart-grid {
    display: grid;
    grid-template-columns: 4fr 12fr 8fr 4fr 4fr 1fr;
    align-items: center;
    padding: 16px;
    margin-bottom: 5px;
    border-bottom: 1px solid rgba(168, 168, 168, 0.7);
  }
  .header {
    padding: 2px 2px;
  }
  .cell {
    padding: 2px 2px;
    &.counter {
      display: flex;
      align-items: center;
    }
    .trash {
      cursor: pointer;
    }
  }
  .footer {
    font-weight: bold;
  }
}

@media screen and (max-width: 600px) {
  .cart-full {
    margin-left: -15px;
    margin-right: -15px;
    .cart-grid {
      padding: 8px 0 8px 6px;
      grid-template-columns: 2fr 7fr 7fr 3fr 3fr 3fr;
      .header {
        font-size: 12px;
      }

      .cell {
        font-size: 11px;
        padding: 2px 2px;
      }

      .footer {
        font-size: 12px;
      }
    }
  }
}
</style>
